document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dc-wrapper').forEach(initCarousel);
});

function initCarousel(wrapper) {
  const track = wrapper.querySelector('.dc-track');
  const slides = Array.from(track.children);
  const viewport = wrapper.querySelector('.dc-track-viewport');
  const prevBtn = wrapper.querySelector('.dc-prev');
  const nextBtn = wrapper.querySelector('.dc-next');
  const dotsWrap = wrapper.querySelector('.dc-dots');

  if (!slides.length) return;

  let currentIndex = 0;
  let autoplayTimer = null;

  const autoplay = wrapper.dataset.autoplay === 'true';
  const speed = (parseFloat(wrapper.dataset.speed) || 4) * 1000;

  // Values controlled from Theme Customizer (backend)
  const slidesDesktop = parseInt(wrapper.dataset.slidesDesktop, 10) || 4;
  const slidesLaptop = parseInt(wrapper.dataset.slidesLaptop, 10) || 3;
  const slidesTablet = parseInt(wrapper.dataset.slidesTablet, 10) || 2;
  const slidesMobile = parseInt(wrapper.dataset.slidesMobile, 10) || 1;

  function getSlidesPerView() {
    const w = window.innerWidth;
    if (w <= 749) return slidesMobile;   // Mobile
    if (w <= 989) return slidesTablet;   // Tablet
    if (w <= 1200) return slidesLaptop;  // Laptop
    return slidesDesktop;                // Desktop
  }

  let slidesPerView = getSlidesPerView();

  function applySlideWidths() {
    const widthPercent = 100 / slidesPerView;
    slides.forEach((slide) => {
      slide.style.flex = `0 0 ${widthPercent}%`;
    });
  }

  function maxIndex() {
    return Math.max(0, slides.length - slidesPerView);
  }

  function renderDots() {
    dotsWrap.innerHTML = '';
    const dotCount = maxIndex() + 1;
    if (dotCount <= 1) return;
    for (let i = 0; i < dotCount; i++) {
      const dot = document.createElement('span');
      dot.className = 'dc-dot' + (i === currentIndex ? ' active' : '');
      dot.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(dot);
    }
  }

  function update() {
    const slideWidth = slides[0].getBoundingClientRect().width;
    track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
    renderDots();
  }

  function goTo(index) {
    currentIndex = Math.min(Math.max(index, 0), maxIndex());
    update();
  }

  function next() {
    currentIndex = currentIndex >= maxIndex() ? 0 : currentIndex + 1;
    update();
  }

  function prev() {
    currentIndex = currentIndex <= 0 ? maxIndex() : currentIndex - 1;
    update();
  }

  function startAutoplay() {
    if (!autoplay || slides.length <= slidesPerView) return;
    stopAutoplay();
    autoplayTimer = setInterval(next, speed);
  }

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  nextBtn.addEventListener('click', () => { next(); startAutoplay(); });
  prevBtn.addEventListener('click', () => { prev(); startAutoplay(); });

  wrapper.addEventListener('mouseenter', stopAutoplay);
  wrapper.addEventListener('mouseleave', startAutoplay);

  window.addEventListener('resize', () => {
    slidesPerView = getSlidesPerView();
    applySlideWidths();
    currentIndex = Math.min(currentIndex, maxIndex());
    update();
  });

  // Basic swipe support for touch devices
  let startX = 0;
  viewport.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    stopAutoplay();
  }, { passive: true });

  viewport.addEventListener('touchend', (e) => {
    const diff = e.changedTouches[0].clientX - startX;
    if (diff > 50) prev();
    else if (diff < -50) next();
    startAutoplay();
  }, { passive: true });

  applySlideWidths();
  update();
  startAutoplay();
}